export const removeNonASCIIChars = (string) => {
    let ascii = '';
    // https://yellowpipe.com/yis/tools/ASCII-HTML-Characters/

    for (let char = 0; char < string.length; char++) {
        if (string.charCodeAt(char) <= 253 ||
            [
                353,
            ].includes(string.charCodeAt(char))) {

            ascii += string.charAt(char);
        }
    }

    return ascii;
};

